  document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('scrollContainer');
    const leftBtn = document.querySelector('.scroll-left');
    const rightBtn = document.querySelector('.scroll-right');

    function updateButtons() {
      leftBtn.style.display = container.scrollLeft > 0 ? 'flex' : 'none';
      rightBtn.style.display = container.scrollLeft + container.clientWidth < container.scrollWidth ? 'flex' : 'none';
    }

    leftBtn.addEventListener('click', () => {
      container.scrollBy({ left: -300, behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', () => {
      container.scrollBy({ left: 300, behavior: 'smooth' });
    });

    container.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });